"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailType = void 0;
var EmailType;
(function (EmailType) {
    EmailType["WELCOME"] = "WELCOME";
    EmailType["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
    EmailType["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    EmailType["RESTORE_PASSWORD"] = "RESTORE_PASSWORD";
})(EmailType || (exports.EmailType = EmailType = {}));
//# sourceMappingURL=eml.js.map